import { render, staticRenderFns } from "./SafeExitButton.vue?vue&type=template&id=407cc680&scoped=true"
import script from "./SafeExitButton.vue?vue&type=script&lang=js"
export * from "./SafeExitButton.vue?vue&type=script&lang=js"
import style0 from "./SafeExitButton.vue?vue&type=style&index=0&id=407cc680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cc680",
  null
  
)

export default component.exports